@let blok = story();
@if (blok) {
    <s1-cms-component [blok]="blok.content"
                      [extraInputs]="{layout: layout()}">
    </s1-cms-component>
} @else {
  <!-- TODO proper 404 page -->
  <h1>404</h1>
  <p>Your story is gone</p>
}
